import PubSub from "underpub-js";
import gsap from 'gsap';

var DropdownInfoItem = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-DropdownInfoItem',
		isToggled: false,
	};

	$.extend(true, this.options, options);

};

DropdownInfoItem.prototype.init = function() {

	var self = this;

	self.animationTl = null;
	self.$toggle = self.options.$el.find(`.${self.options.baseClass}__toggle`);
	self.$toggleLine = self.$toggle.find(`.${self.options.baseClass}__toggle__icon__line`).get(0);
	self.$copy = self.options.$el.find(`.${self.options.baseClass}__copy`);

	self.initAnimation();

	PubSub.subscribe('Sitewide:resized', function() {
		self.animationTl.invalidate(); // invalidate on resize so GSAP recalculates the value of height:auto
	});

	self.$toggle.on('click', () => self.toggle());

};

DropdownInfoItem.prototype.initAnimation = function() {

	var self = this;

	self.animationTl = gsap
		.timeline({
			paused: true,
			reversed: true,
		})
		.fromTo(self.$toggleLine,
			{
				rotate: "90deg",
			},
			{
				duration: 0.3,
				rotate: 0,
			}
		)
		.fromTo(self.$copy,
			{
				height: 0,
			},
			{
				duration: 0.3,
				height: "auto",
			}
		, "<")

};

DropdownInfoItem.prototype.toggle = function () {
	const self = this;
	!self.options.isToggled ? self.toggleOn() : self.toggleOff();
	self.toggleState();
};

DropdownInfoItem.prototype.toggleState = function () {
	const self = this;
	self.options.isToggled = !self.options.isToggled;
	console.log('toggle state');
	console.log(self.options.isToggled);
};

DropdownInfoItem.prototype.toggleOn = function (speed = 1) {
	const self = this;
	self.animationTl.timeScale(speed).play();
	self.options.$el.addClass(`${self.options.baseClass}--active`);
};

DropdownInfoItem.prototype.toggleOff = function (speed = 1.4) {
	const self = this;
	self.animationTl.timeScale(speed).reverse();
	self.options.$el.removeClass(`${self.options.baseClass}--active`);
};

export default DropdownInfoItem;
